import React, {
    createContext,
    ReactNode,
    useCallback,
    useMemo,
    useState,
} from "react";
import { ModalWarehouseField } from "../constants/types";

interface State {
    isOpenModalWarehouse: boolean;
    dataWarehouse?: ModalWarehouseField;
    openModalWarehouse: (data?: ModalWarehouseField) => void;
    closeModalWarehouse: () => void;
}

interface IWarehouseModalContext {
    children: ReactNode;
}

const WarehouseModalContext = createContext<State | undefined>(undefined);

const WarehouseModalProvider = ({ children }: IWarehouseModalContext) => {
    const [isOpenModalWarehouse, setIsOpenModalWarehouse] = useState(false);
    const [dataWarehouse, setDataWarehouse] = useState<ModalWarehouseField>();

    const openModalWarehouse = useCallback((data?: ModalWarehouseField) => {
        if (data) {
            setDataWarehouse((prev) => ({
                ...prev,
                ...data,
            }));
        }

        setIsOpenModalWarehouse(true);
    }, []);

    const closeModalWarehouse = useCallback(() => {
        setIsOpenModalWarehouse(false);
        setDataWarehouse(undefined);
    }, []);

    const value = useMemo(
        () => ({
            isOpenModalWarehouse,
            dataWarehouse,
            openModalWarehouse,
            closeModalWarehouse,
        }),
        [
            isOpenModalWarehouse,
            dataWarehouse,
            openModalWarehouse,
            closeModalWarehouse,
        ],
    );

    return (
        <WarehouseModalContext.Provider value={value}>
            {children}
        </WarehouseModalContext.Provider>
    );
};

const useWarehouseModal = () => {
    const context = React.useContext(WarehouseModalContext);
    if (context === undefined) {
        throw new Error(
            "useWarehouseModal must be used within a WarehouseModalProvider",
        );
    }
    return context;
};

export { WarehouseModalContext, WarehouseModalProvider, useWarehouseModal };
